"use client";

import { useState, useCallback } from "react";

const STORAGE_KEY = "spark-recent-clients";
const MAX_RECENT = 5;

export interface RecentClient {
  id: string;
  name: string;
}

function readStorage(): RecentClient[] {
  if (typeof window === "undefined") return [];
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
  } catch {
    return [];
  }
}

export function useRecentClients() {
  const [recentClients, setRecentClients] = useState<RecentClient[]>(readStorage);

  const recordVisit = useCallback((id: string, name: string) => {
    setRecentClients((prev) => {
      const next = [{ id, name }, ...prev.filter((c) => c.id !== id)].slice(0, MAX_RECENT);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  const pruneRecentClients = useCallback((allowedIds: Set<string>) => {
    setRecentClients((prev) => {
      const next = prev.filter((c) => allowedIds.has(c.id));
      if (next.length === prev.length) return prev;
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return { recentClients, recordVisit, pruneRecentClients };
}
